export default __webpack_public_path__ + "media/gyomuSuper.666b0122.png";